import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function WhoIsFor() {
  const forWho = ['Mujeres que valoran su independencia y quieren mantener el control.', 'Madres que desean facilitarle la vida a sus hijos en momentos difíciles.', 'Personas que tienen sus documentos dispersos en diferentes sobres o cajones.', 'Abuelas que quieren que su legado emocional sea tan ordenado como su hogar.'];
  const notForWho = ['Personas que buscan un reemplazo legal para un testamento (esto es un complemento organizativo).', 'Quienes no están dispuestos a dedicar 15 minutos a poner orden.'];
  return <section className="py-20 md:py-32 px-6 bg-cream" data-id="element-191">
      <div className="max-w-5xl mx-auto" data-id="element-192">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-193">
          {/* Para ti si... */}
          <FadeIn direction="right" data-id="element-194">
            <div className="bg-card p-8 md:p-10 rounded-3xl shadow-warm border-t-4 border-sage" data-id="element-195">
              <h3 className="font-serif text-2xl text-charcoal mb-8 font-semibold" data-id="element-196">
                Este kit es para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-197">
                {forWho.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-198">
                    <CheckCircleIcon className="w-6 h-6 text-sage flex-shrink-0 mt-1" data-id="element-199" />
                    <span className="text-charcoal leading-relaxed" data-id="element-200">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* No es para ti si... */}
          <FadeIn direction="left" delay={0.2} data-id="element-201">
            <div className="bg-card/50 p-8 md:p-10 rounded-3xl border border-muted/20" data-id="element-202">
              <h3 className="font-serif text-2xl text-muted mb-8 font-semibold" data-id="element-203">
                No es para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-204">
                {notForWho.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-205">
                    <XCircleIcon className="w-6 h-6 text-muted/50 flex-shrink-0 mt-1" data-id="element-206" />
                    <span className="text-muted leading-relaxed" data-id="element-207">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}